






























import { addSelectItem, updateSelectItem } from '@/api/admin'
import { SelectItem } from '@/api/types-app'
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'SelectItem',
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { attrs }) {
    const modelValue = ref<SelectItem>((attrs['v-model'] as SelectItem))

    const selectItemListName = ref(null)
    const selectItemModal = ref(false)
    const currentSelectItem = ref(null)

    const editItem = async(selectItem: SelectItem) => {
      const result = await updateSelectItem(modelValue.value)
      // eslint-disable-next-line no-self-assign
      if (result) window.location.href = window.location.href
    }

    const addNewSelectItem = async() => {
      const result = await addSelectItem(modelValue.value)
      // eslint-disable-next-line no-self-assign
      if (result) window.location.href = window.location.href
    }

    return {
      modelValue,
      selectItemListName,
      selectItemModal,
      currentSelectItem,
      editItem,
      addNewSelectItem
    }
  }
})
